module.exports = __webpack_public_path__ + "980b3bf56a36568dd5a1c62a6607c3e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./2017-04-25-harrison/hammock2.jpg
// module id = 992
// module chunks = 0